const els = {
    $numbers: () => $('[data-numbers]'),
    $heading: () => els.$numbers().find('[data-heading]'),
    $headingText: () => els.$heading().find('[data-text]'),
    $headingPole: () => els.$heading().find('[data-pole]'),
    $blocksWrap: () => els.$numbers().find('[data-blocks]'),
    $blocks: () => els.$numbers().find('[data-block]'),
    $largeBlocks: () => els.$blocks().filter('[data-block="large"]'),
    $smallBlocks: () => els.$blocks().filter('[data-block="small"]'),
    $largeBlockLabels: () => els.$largeBlocks().find('[data-label]'),
    $smallBlockValues: () => els.$smallBlocks().find('[data-value]'),
    $link: () => els.$numbers().find('[data-link]'),
};

export default els;

